import { Fragment, useContext, useState } from "react";
import { menuRoutes } from "../../../router/menu";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import cn from "../../../utils/classNames";
import { Button } from "rizzui";
import ProviderInvoicesList from "./ProvidersInvoiceList";
import { ProviderInvoice } from "../../../type/entities/provider-invoice-type";
import ModalQuarterlyBilling from "../components/ModalQuarterlyBilling";

const ProvidersInvoicesListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [isOpenModalAutoInvoice, setIsOpenModalAutoInvoice] = useState(false);
    const [isOpenModalQuarterlyBilling, setIsOpenModalQuarterlyBilling] = useState(false);
    const [providerInvoiceSelected, setProviderInvoiceSelected] = useState<ProviderInvoice | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de facturación' },
        { name: 'Facturación', href: menuRoutes.providersInvoices.path },
    ];

    const defaultFilters = {};

    // HOOKS 

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de facturación" breadcrumb={breadCrumb}>
                    <div>
                        {
                            userCan('create', 'provider_invoicing') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => { 
                                        setIsOpenFormDrawer(true) 
                                        setProviderInvoiceSelected(null)
                                    }}
                                    className={cn(['mt-4 md:mt-0 mx-2'])}
                                >
                                    Crear factura
                                </Button>
                            )
                        }
                        {/* {
                            userCan('auto-invoices', 'provider_invoicing') &&
                            ( */}
                                {/* <Button
                                    color="secondary"
                                    onClick={() => { 
                                        setIsOpenModalAutoInvoice(true) 
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Facturación automática
                                </Button> */}
                                <Button
                                    color="secondary"
                                    variant="outline"
                                    onClick={() => setIsOpenModalQuarterlyBilling(true)}
                                    className={cn(['mt-4 md:mt-0 mx-2'])}
                                >
                                    Facturación trimestral automática
                                </Button>
                            {/* ) */}
                        {/* } */}
                    </div>
                </PageHeader>
                <ProviderInvoicesList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} openModalAutoInvoice={isOpenModalAutoInvoice} setOpenModalAutoInvoice={setIsOpenModalAutoInvoice} providerInvoiceSelected={providerInvoiceSelected} setProviderInvoiceSelected={setProviderInvoiceSelected} />
                <ModalQuarterlyBilling
                    isOpen={isOpenModalQuarterlyBilling}
                    onClose={() => setIsOpenModalQuarterlyBilling(false)}
                />
            </FiltersProvider>
        </Fragment>
    );
}

export default ProvidersInvoicesListWrapper;
